//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import InquiryType from '~/components/search/inquiry/mixins/InquiryType'

export default {

    name: 'InquiryGeneral',

    mixins: [ InquiryType ],

    props: {
        reference: {
        },
        inquiryType: {
        },
        inquiryFavlistId: {
        },
        countries: {
        },
        contact: {
        },
        general: {
        },
        destinationId: {
        }

    },

    data() {
        return {
            step: 'contact',
        }
    },

    methods: {

        onSubmit() {

            let _this = this
            let rfpFile = ''
            let rfpFileOrigName = ''


            if(this.general.fileDocument && this.general.fileDocument !== null) {
                rfpFile = this.general.fileDocument.upload.data.fileName
                rfpFileOrigName = this.general.fileDocument.upload.origFilename
            }

            const formData = {

                'request_type': 'general',
                'request_id': this.reference,

                'inquiry_type': this.inquiryType,

                'destination_id': this.destinationId,

                'inquiry_favlist_id': this.inquiryFavlistId,

                'general_company': this.contact.company,
                'general_firstname': this.contact.firstName,
                'general_lastname': this.contact.lastName,
                'general_jobtitle': this.contact.jobTitle,
                'general_email': this.contact.email,
                'general_phone': this.contact.phoneNumber,
                'general_country': this.contact.country.id,
                'general_request_description': this.general.description,

                'rfpFile': rfpFile,
                'rfpFileOrigName': rfpFileOrigName,
            }

            this.$axios.post(this.$ziggy.route('search.inquiry.send'), formData)
                .then((response) => {
                    _this.$logger.debug('send rfp', response)
                    _this.$emit('step', 'successful')
                })
                .catch((e) => {
                    this.$toast.global.my_error()
                    _this.$logger.captureException(e)
                })

        },

    },


}

